// ** react imports

// ** views imports
import AccountPanel from '../../../views/users/AddUsers/AccountPanel';

function AddUser() {
  return (
    <div className="flex ">
      <main className="grow">
        <div className="px-4 sm:px-6 lg:px-8 py-6 w-full max-w-[96rem] mx-auto">
          {/* Page header */}
          <div className="mb-8">
            {/* Title */}
            <h1 className="text-2xl md:text-3xl text-gray-800 dark:text-gray-100 font-bold">
              Invite New Manager
            </h1>
          </div>

          {/* Content */}
          <div className="bg-white dark:bg-gray-800 shadow-xs rounded-xl mb-8">
            <AccountPanel />
          </div>
        </div>
      </main>
    </div>
  );
}

export default AddUser;
